import _ from 'lodash';

export function capitalizeFirstLetter(str: string) {
  return _.capitalize(str);
}

export function snakeCaseToTitleCase(inputString: string, variant = 'snake') {
  if (variant === 'snake') {
    const words = inputString.split('_');
    const titleCaseString = words
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
    return titleCaseString;
  } else {
    const words = inputString.split('-');
    const titleCaseString = words
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
    return titleCaseString;
  }
}

export function convertToTitleCase(
  inputString: string,
  separator: string = '_',
): string {
  return _.startCase(_.toLower(inputString.split(separator).join(' ')));
}

export function capitalizeAllFirstLetter(str: string) {
  return _.startCase(str);
}
